/**
 * DRM Profile entity class
 */

import { SECURITY_LEVEL_TYPES } from 'app/core/constants'

/**
 * DRMProfileFactory
 * returns DRM Profile entity class
 *
 * @class DRMProfileFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DRMProfile} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DRMProfile
 */
/* @ngInject */
export default function DRMProfileFactory ($http, Entity, Type, m2mMixin, onOffMixin) {
  /* === DRMProfile class === */

  /**
   * DRMProfile model
   *
   * @class DRMProfile
   * @classdesc DRMProfile model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @return {models.DRMProfile} DRMProfile entity
   */
  function DRMProfile () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DRMProfile.prototype = Object.create(Entity.prototype)
  DRMProfile.prototype.constructor = DRMProfile

  /* === DRMProfile instance methods & fields === */

  Object.assign(DRMProfile.prototype, {

    /**
     * instance fields
     *
     * @memberof models.DRMProfile#
     * @type {Object}
     */
    _fields: {
      id: Number,
      drmAccountId: Number,
      name: String,
      enabled: true,
      callbackUrl: String,
      drmType: String,
      fpsCertificate: String,
      fpsCertificateFileName: String,
      hardwareDrmRequired: Boolean,
      hdcpType: 'NO_HDCP',
      integrationType: 'TOKEN',
      licenseDurationSec: 0,
      rentalDurationSec: 0,
      outputProtectionLevel: 0,
      persistentLicense: false,
      playReadySecurityLevel: Object.keys(SECURITY_LEVEL_TYPES)[0],
      providerType: String,
      robustnessLevel: 'SW_SECURE_CRYPTO',
      rootedDeviceAllowed: Boolean,
      keyStorageUrl: String,
      tokenRequestUrl: String,
      $licenseLimitation: false
    },

    /**
     * url template
     *
     * @memberof models.DRMProfile#
     * @type {String}
     */
    _urlTemplate: 'api/drm/accounts/{{::drmAccountId}}/profiles/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.DRMAccount#
     * @type {String}
     */
    _publicUrlTemplate: 'drmaccounts/{{::drmAccountId}}',

    /**
     * Prepare account
     *
     * @memberof models.DRMAccount#
     * @override
     */
    _prepare: function () {
      this.$licenseLimitation = !!this.licenseDurationSec

      if (this.outputProtectionLevel === null) {
        this.outputProtectionLevel = 0
      }

      if (this.licenseDurationSec === null) {
        this.licenseDurationSec = 0
      }

      if (this.rentalDurationSec === null) {
        this.rentalDurationSec = 0
      }
    },

    /**
     * Get underlying object
     *
     * @memberof models.DRMAccount#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      var ret = Entity.prototype._object.apply(this, arguments)

      if (ret.outputProtectionLevel === null) {
        ret.outputProtectionLevel = 0
      }

      return ret
    }

  }, onOffMixin)

  /* === DRM Profile static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DRMProfile, Entity)
  DRMProfile._name = 'DRMProfile'
  DRMProfile._noCache = true
  DRMProfile.init()

  // permissions
  DRMProfile.access = {
    view: 'viewDRMProfile',
    create: 'createDRMProfile',
    edit: 'editDRMProfile',
    delete: 'deleteDRMProfile'
  }

  return DRMProfile
}
